/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Api
 * Mooya Dealer Portal API
 * OpenAPI spec version: 0.1.0
 */
export interface HealthStatus {
  status: string;
}

export interface Error {
  error: string;
}

export interface UploadUrlRequest {
  /**
     * Original file name.
     * @minLength 1
     */
  name: string;
  /**
     * File size in bytes.
     * @minimum 1
     */
  size: number;
  /**
     * MIME type of the file (e.g. `image/jpeg`).
     * @minLength 1
     */
  contentType: string;
}

export interface UploadUrlResponse {
  /** Presigned GCS URL for PUT upload. */
  uploadURL: string;
  /** Normalized object path (e.g. `/objects/uploads/uuid`). */
  objectPath: string;
  metadata?: UploadUrlRequest;
}

export type OnboardingStatus = typeof OnboardingStatus[keyof typeof OnboardingStatus];


export const OnboardingStatus = {
  in_progress: 'in_progress',
  submitted: 'submitted',
  changes_requested: 'changes_requested',
  approved: 'approved',
  rejected: 'rejected',
} as const;

export type DocumentReviewStatus = typeof DocumentReviewStatus[keyof typeof DocumentReviewStatus];


export const DocumentReviewStatus = {
  pending: 'pending',
  accepted: 'accepted',
  rejected: 'rejected',
} as const;

export type OnboardingDocumentKey = typeof OnboardingDocumentKey[keyof typeof OnboardingDocumentKey];


export const OnboardingDocumentKey = {
  id_document: 'id_document',
  proof_of_address: 'proof_of_address',
  bank_confirmation: 'bank_confirmation',
} as const;

export interface OnboardingDocumentReview {
  documentKey: OnboardingDocumentKey;
  status: DocumentReviewStatus;
  /** Controlled rejection-reason code (see the shared ficaReview list). Present only when status is rejected. */
  rejectionReason?: string | null;
  /** Free-text reviewer comment shown to the agent. */
  comment?: string | null;
  reviewedAt?: number | null;
}

export interface OnboardingDocumentReviewInput {
  documentKey: OnboardingDocumentKey;
  status: DocumentReviewStatus;
  rejectionReason?: string | null;
  comment?: string | null;
}

export interface Onboarding {
  currentStep: number;
  status: OnboardingStatus;
  fullName?: string | null;
  idNumber?: string | null;
  phone?: string | null;
  addressLine?: string | null;
  city?: string | null;
  province?: string | null;
  postalCode?: string | null;
  agentType?: string | null;
  preferredOperatingArea?: string | null;
  bankName?: string | null;
  accountNumber?: string | null;
  accountType?: string | null;
  branchCode?: string | null;
  idDocumentPath?: string | null;
  proofOfAddressPath?: string | null;
  bankConfirmationPath?: string | null;
  profilePhotoPath?: string | null;
  submittedAt?: number | null;
  /** Feedback from the reviewing account manager. Populated when the application is rejected or changes are requested. */
  reviewerNotes?: string | null;
  reviewedAt?: number | null;
  /** Whether an agent must upload a profile photo before their onboarding can be submitted for approval. Controlled server-side by a single flag so it can be turned on without a client change. */
  profilePhotoRequired: boolean;
  /** Per-document FICA review decisions. Empty until a reviewer records decisions; lets the agent see exactly which document was rejected and why. */
  documentReviews: OnboardingDocumentReview[];
}

export interface UpdateOnboardingBody {
  currentStep?: number;
  fullName?: string;
  idNumber?: string;
  phone?: string;
  addressLine?: string;
  city?: string;
  province?: string;
  postalCode?: string;
  agentType?: string;
  preferredOperatingArea?: string;
  bankName?: string;
  accountNumber?: string;
  accountType?: string;
  branchCode?: string;
  idDocumentPath?: string;
  proofOfAddressPath?: string;
  bankConfirmationPath?: string;
  profilePhotoPath?: string;
}

export interface OnboardingReview {
  id: number;
  userId: number;
  /** True when the applicant's mobile number was verified via the account-activation SMS OTP (account_activations.smsVerifiedAt set). Approval is blocked server-side unless this is true. */
  phoneVerified: boolean;
  applicantName: string;
  applicantEmail: string;
  currentStep: number;
  status: OnboardingStatus;
  fullName?: string | null;
  idNumber?: string | null;
  phone?: string | null;
  addressLine?: string | null;
  city?: string | null;
  province?: string | null;
  postalCode?: string | null;
  agentType?: string | null;
  preferredOperatingArea?: string | null;
  bankName?: string | null;
  accountNumber?: string | null;
  accountType?: string | null;
  branchCode?: string | null;
  idDocumentPath?: string | null;
  proofOfAddressPath?: string | null;
  bankConfirmationPath?: string | null;
  profilePhotoPath?: string | null;
  submittedAt?: number | null;
  reviewerNotes?: string | null;
  reviewedAt?: number | null;
  reviewedByUserId?: number | null;
  createdAt: number;
  documentReviews: OnboardingDocumentReview[];
}

export type OnboardingReviewUpdateStatus = typeof OnboardingReviewUpdateStatus[keyof typeof OnboardingReviewUpdateStatus];


export const OnboardingReviewUpdateStatus = {
  approved: 'approved',
  rejected: 'rejected',
  changes_requested: 'changes_requested',
} as const;

export interface OnboardingApprovalAssignment {
  areaId?: number;
  masterDealerId?: number;
  accountManagerId?: number;
  openserveDealerCode?: string;
}

export interface OnboardingReviewUpdate {
  status: OnboardingReviewUpdateStatus;
  reviewerNotes?: string | null;
  /** Per-document decisions submitted with the overall review. Approval is rejected by the server unless every uploaded FICA document is accepted. */
  documentReviews?: OnboardingDocumentReviewInput[];
  /** Agent placement captured at approval and written onto the agent record. REQUIRED when status is "approved": the server rejects the approval unless areaId, accountManagerId and a non-empty openserveDealerCode are present. masterDealerId is optional and defaults to the house dealer (Mooya Wireless) when omitted. Ignored for "rejected" / "changes_requested". */
  assignment?: OnboardingApprovalAssignment;
}

export type UserRole = typeof UserRole[keyof typeof UserRole];


export const UserRole = {
  agent: 'agent',
  master_dealer: 'master_dealer',
  account_manager: 'account_manager',
  admin: 'admin',
  finance: 'finance',
  support: 'support',
  poc_support: 'poc_support',
  operations: 'operations',
} as const;

export type UserStatus = typeof UserStatus[keyof typeof UserStatus];


export const UserStatus = {
  active: 'active',
  suspended: 'suspended',
} as const;

export type StaffInvitationStatus = typeof StaffInvitationStatus[keyof typeof StaffInvitationStatus];


export const StaffInvitationStatus = {
  pending: 'pending',
  accepted: 'accepted',
  expired: 'expired',
  revoked: 'revoked',
} as const;

export type AgentStatus = typeof AgentStatus[keyof typeof AgentStatus];


export const AgentStatus = {
  active: 'active',
  pending: 'pending',
  suspended: 'suspended',
  new_lead: 'new_lead',
  invited: 'invited',
  accepted: 'accepted',
  attended: 'attended',
  no_show: 'no_show',
} as const;

export type AgentType = typeof AgentType[keyof typeof AgentType];


export const AgentType = {
  independent_technician: 'independent_technician',
  field_sales: 'field_sales',
  master_dealer: 'master_dealer',
  digital_partner: 'digital_partner',
} as const;

export type OrderStatus = typeof OrderStatus[keyof typeof OrderStatus];


export const OrderStatus = {
  pending: 'pending',
  in_progress: 'in_progress',
  action_required: 'action_required',
  hoa_approved: 'hoa_approved',
  pending_build: 'pending_build',
  installed: 'installed',
  active: 'active',
  cancelled: 'cancelled',
  rejected: 'rejected',
} as const;

export type ApplicationStatus = typeof ApplicationStatus[keyof typeof ApplicationStatus];


export const ApplicationStatus = {
  pending: 'pending',
  action_required: 'action_required',
  approved: 'approved',
  rejected: 'rejected',
  training_in_progress: 'training_in_progress',
  invited_to_info_session: 'invited_to_info_session',
  attended_info_session: 'attended_info_session',
  started_pre_session: 'started_pre_session',
  started_post_session: 'started_post_session',
  declined_no_show: 'declined_no_show',
} as const;

export type PayoutStatus = typeof PayoutStatus[keyof typeof PayoutStatus];


export const PayoutStatus = {
  included: 'included',
  held: 'held',
  paid: 'paid',
  pending: 'pending',
  processing: 'processing',
  failed: 'failed',
} as const;

export type TransactionType = typeof TransactionType[keyof typeof TransactionType];


export const TransactionType = {
  payout: 'payout',
  once_off_connection_fee: 'once_off_connection_fee',
  recurring_commission: 'recurring_commission',
  basic_retainer: 'basic_retainer',
} as const;

export type DisputeStatus = typeof DisputeStatus[keyof typeof DisputeStatus];


export const DisputeStatus = {
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected',
  action_required: 'action_required',
} as const;

export type TicketStatus = typeof TicketStatus[keyof typeof TicketStatus];


export const TicketStatus = {
  new: 'new',
  in_progress: 'in_progress',
  waiting_on_agent: 'waiting_on_agent',
  resolved: 'resolved',
} as const;

export type TicketPriority = typeof TicketPriority[keyof typeof TicketPriority];


export const TicketPriority = {
  high: 'high',
  medium: 'medium',
  low: 'low',
} as const;

export type InvitationStatus = typeof InvitationStatus[keyof typeof InvitationStatus];


export const InvitationStatus = {
  invited: 'invited',
  accepted: 'accepted',
  attended: 'attended',
  no_show: 'no_show',
  declined: 'declined',
  expired: 'expired',
} as const;

export type InvitationChannel = typeof InvitationChannel[keyof typeof InvitationChannel];


export const InvitationChannel = {
  sms: 'sms',
  email: 'email',
  whatsapp: 'whatsapp',
} as const;

export type BankChangeStatus = typeof BankChangeStatus[keyof typeof BankChangeStatus];


export const BankChangeStatus = {
  pending: 'pending',
  action_required: 'action_required',
  approved: 'approved',
  rejected: 'rejected',
  verified: 'verified',
} as const;

export type InfoSessionStatus = typeof InfoSessionStatus[keyof typeof InfoSessionStatus];


export const InfoSessionStatus = {
  scheduled: 'scheduled',
  completed: 'completed',
  cancelled: 'cancelled',
} as const;

export type DataImportStatus = typeof DataImportStatus[keyof typeof DataImportStatus];


export const DataImportStatus = {
  pending: 'pending',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed',
} as const;

export type PaymentRunStatus = typeof PaymentRunStatus[keyof typeof PaymentRunStatus];


export const PaymentRunStatus = {
  draft: 'draft',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;

export interface CurrentUser {
  id: number;
  clerkUserId?: string;
  email: string;
  /** @nullable */
  firstName?: string | null;
  /** @nullable */
  lastName?: string | null;
  fullName: string;
  role: UserRole;
  status?: UserStatus;
  /** @nullable */
  avatarUrl?: string | null;
  /** @nullable */
  agentId?: number | null;
  /** @nullable */
  masterDealerId?: number | null;
  /** @nullable */
  accountManagerId?: number | null;
  /** @nullable */
  dealerCode?: string | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  jobTitle?: string | null;
  /** True once the user has completed dual-OTP account activation (email + SMS). Derived from activatedAt; always present on GET /me. */
  activated?: boolean;
  /** True once an internal-staff / account-manager user has completed their profile. Always true for agents (they use onboarding instead). Derived; always present on GET /me. */
  profileComplete?: boolean;
  createdAt?: string;
}

export interface RoleUpdate {
  role: UserRole;
}

export interface StaffInvitation {
  id: number;
  email: string;
  role: UserRole;
  status: StaffInvitationStatus;
  invitedByUserId: number;
  /** @nullable */
  acceptedByUserId?: number | null;
  /** @nullable */
  acceptedAt?: string | null;
  /** @nullable */
  revokedAt?: string | null;
  expiresAt: string;
  createdAt: string;
}

export interface StaffInviteInput {
  /** @minLength 1 */
  email: string;
  role: UserRole;
}

export type StaffInvitationResult = StaffInvitation & ({
  /** Whether the invitation email was accepted for delivery by the provider. */
  delivered: boolean;
  /**
     * If delivery failed, a human-readable reason; otherwise null.
     * @nullable
     */
  deliveryError?: string | null;
  /**
     * Provider-assigned message identifier when available.
     * @nullable
     */
  providerMessageId?: string | null;
});

export interface AdminUserUpdate {
  role?: UserRole;
  status?: UserStatus;
  /** @nullable */
  firstName?: string | null;
  /** @nullable */
  lastName?: string | null;
  /** @minLength 1 */
  fullName?: string;
}

export interface StatItem {
  label: string;
  value: string;
  /** @nullable */
  helpText?: string | null;
}

/**
 * Aggregate counts of the agent's leads (orders) by outcome bucket, computed server-side over the agent's full lead set. converted = installed + active; inProgress = pending + in_progress + action_required + pending_build + hoa_approved; failed = cancelled + rejected; total = every lead. Powers the home Leads stats grid.
 */
export type AgentDashboardLeadStats = {
  total: number;
  converted: number;
  inProgress: number;
  failed: number;
};

/**
 * @nullable
 */
export type AgentDashboardAccountManager = {
  name?: string;
  email?: string;
  /** @nullable */
  phone?: string | null;
} | null;

export interface Order {
  id: number;
  reference: string;
  customerName: string;
  /** @nullable */
  address?: string | null;
  package: string;
  priceCents: number;
  isp?: string;
  status: OrderStatus;
  /** @nullable */
  agentId?: number | null;
  /** @nullable */
  agentName?: string | null;
  submittedAt?: string;
  /** @nullable */
  externalLeadId?: string | null;
  /** @nullable */
  leadStatus?: string | null;
  /** @nullable */
  leadType?: string | null;
  /** @nullable */
  contactNumber?: string | null;
  /** @nullable */
  contactEmail?: string | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  dealer?: string | null;
  /** @nullable */
  capturedByEmail?: string | null;
  /** @nullable */
  dateCaptured?: string | null;
  /** @nullable */
  externalLastUpdated?: string | null;
  /** @nullable */
  installedAt?: string | null;
}

export interface Transaction {
  id: number;
  reference: string;
  /** @nullable */
  agentId?: number | null;
  /** @nullable */
  agentName?: string | null;
  amountCents: number;
  type: TransactionType;
  status: PayoutStatus;
  /** @nullable */
  heldReason?: string | null;
  /** @nullable */
  orderId?: number | null;
  /** @nullable */
  periodMonth?: string | null;
  createdAt?: string;
}

export interface AgentDashboard {
  /** Whether an entity scope was resolved for this response. true when the dashboard is rendering entity-scoped data (the caller's linked record, or — outside production only — a demo fallback entity). false when no entity resolved; clients should show an "account not linked" empty state instead of the zeroed metrics. */
  linked: boolean;
  activeClients: number;
  pendingOrders: number;
  balanceDueCents: number;
  /** Aggregate counts of the agent's leads (orders) by outcome bucket, computed server-side over the agent's full lead set. converted = installed + active; inProgress = pending + in_progress + action_required + pending_build + hoa_approved; failed = cancelled + rejected; total = every lead. Powers the home Leads stats grid. */
  leadStats: AgentDashboardLeadStats;
  /** @nullable */
  accountManager?: AgentDashboardAccountManager;
  recentOrders: Order[];
  recentEarnings: Transaction[];
}

export interface AgentFicaDocument {
  documentKey: string;
  label: string;
}

export interface Agent {
  id: number;
  name: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  phone?: string | null;
  /**
     * Legacy/internal mirror of the agent code, kept equal to openserveDealerCode. Never shown on its own — clients display openserveDealerCode (falling back to this for legacy rows).
     * @nullable
     */
  dealerCode?: string | null;
  /** @nullable */
  openserveDealerCode?: string | null;
  /** True when any user linked to this agent verified their mobile via the account-activation SMS OTP (account_activations.smsVerifiedAt set). Surfaced read-only on the agent profile; pre-OTP/grandfathered agents read false. */
  phoneVerified: boolean;
  type: AgentType;
  status: AgentStatus;
  /** @nullable */
  areaId?: number | null;
  /** @nullable */
  areaName?: string | null;
  /** @nullable */
  preferredOperatingArea?: string | null;
  /** @nullable */
  masterDealerId?: number | null;
  /** @nullable */
  accountManagerId?: number | null;
  /** @nullable */
  masterDealerName?: string | null;
  /** @nullable */
  accountManagerName?: string | null;
  /** @nullable */
  lastLeadDate?: string | null;
  /** @nullable */
  commissionPlanId?: number | null;
  /** @nullable */
  commissionPlanName?: string | null;
  /** @nullable */
  daysSinceLastLead?: number | null;
  ordersSubmitted?: number;
  conversionRate?: number;
  activeClients?: number;
  walletBalanceCents?: number;
  createdAt?: string;
  /** @nullable */
  lastLoginAt?: string | null;
  /** @nullable */
  profilePhotoUrl?: string | null;
  /** @nullable */
  onboardingId?: number | null;
  ficaDocuments?: AgentFicaDocument[];
  /** @nullable */
  bankName?: string | null;
  /** @nullable */
  branchCode?: string | null;
  /** @nullable */
  accountType?: string | null;
  /** @nullable */
  accountNumberMasked?: string | null;
  heldPayoutCount?: number;
  heldPayoutCents?: number;
}

export interface MasterDealerDashboard {
  /** Whether an entity scope was resolved for this response. true when the dashboard is rendering entity-scoped data (the caller's linked record, or — outside production only — a demo fallback entity). false when no entity resolved; clients should show an "account not linked" empty state instead of the zeroed metrics. */
  linked: boolean;
  totalActiveClients: number;
  totalTeamRevenueCents: number;
  totalCommissionCents: number;
  activeSubAgents: number;
  subAgents: Agent[];
}

export interface Region {
  id: number;
  name: string;
  code: string;
  /** @nullable */
  accountManagerId?: number | null;
  agentCount?: number;
  createdAt?: string;
}

export interface AccountManagerDashboard {
  /** Whether an entity scope was resolved for this response. true when the dashboard is rendering entity-scoped data (the caller's linked record, or — outside production only — a demo fallback entity). false when no entity resolved; clients should show an "account not linked" empty state instead of the zeroed metrics. */
  linked: boolean;
  totalAgentsManaged: number;
  openTickets: number;
  avgResolutionDays: number;
  workloadScore: number;
  regions: Region[];
}

export interface Application {
  id: number;
  applicantName: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  phone?: string | null;
  agentType?: AgentType;
  status: ApplicationStatus;
  ficaComplete?: boolean;
  /** @nullable */
  idDocumentUrl?: string | null;
  /** @nullable */
  proofOfAddressUrl?: string | null;
  /** @nullable */
  bankConfirmationUrl?: string | null;
  /** @nullable */
  profilePhotoUrl?: string | null;
  /** @nullable */
  reviewerNotes?: string | null;
  /** @nullable */
  openserveAgentId?: string | null;
  /** @nullable */
  masterDealerId?: number | null;
  submittedAt?: string;
}

export interface AdminDashboard {
  pendingReview: number;
  approvedToday?: number;
  rejectedToday?: number;
  applications: Application[];
}

export interface FinanceDashboard {
  totalOnceOffFeesCents: number;
  totalRecurringCommCents: number;
  totalPayoutValueCents: number;
  agentsToPay: number;
  payoutsHeld: number;
  pendingTransactions?: Transaction[];
}

export interface Ticket {
  id: number;
  reference: string;
  subject: string;
  status: TicketStatus;
  priority: TicketPriority;
  /** @nullable */
  agentId?: number | null;
  /** @nullable */
  agentName?: string | null;
  /** @nullable */
  assignedToId?: number | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface SupportDashboard {
  newCount: number;
  inProgressCount: number;
  waitingCount: number;
  resolvedCount: number;
  openTickets: Ticket[];
}

export interface OnboardingFunnelStage {
  key: string;
  label: string;
  count: number;
  dropOffPct: number;
}

export interface OnboardingFunnelLead {
  id: number;
  applicantName: string;
  agentType?: AgentType;
  status: ApplicationStatus;
  ficaComplete: boolean;
  invited: boolean;
  attended: boolean;
  started: boolean;
  /** @nullable */
  masterDealerId?: number | null;
  submittedAt?: string;
}

export interface OnboardingFunnel {
  totalLeads: number;
  sessionAttendanceRate: number;
  onboardingStartRate: number;
  approvedCount: number;
  stages: OnboardingFunnelStage[];
  leads: OnboardingFunnelLead[];
}

export interface RegionInput {
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  code: string;
  accountManagerId?: number;
}

export interface RegionUpdate {
  /** @minLength 1 */
  name?: string;
  /** @minLength 1 */
  code?: string;
  accountManagerId?: number;
}

export interface Area {
  id: number;
  name: string;
  regionId: number;
  /** @nullable */
  suburb?: string | null;
}

export interface AreaInput {
  /** @minLength 1 */
  name: string;
  regionId: number;
  suburb?: string;
}

export interface MasterDealer {
  id: number;
  name: string;
  dealerCode: string;
  /** @nullable */
  contactEmail?: string | null;
  /** @nullable */
  contactPhone?: string | null;
  /** @nullable */
  regionId?: number | null;
  status: AgentStatus;
  commissionSplitPct?: number;
  totalTeamRevenueCents?: number;
  totalCommissionCents?: number;
  activeSubAgents?: number;
  createdAt?: string;
  /** @nullable */
  archivedAt?: string | null;
}

export interface MasterDealerInput {
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  dealerCode: string;
  contactEmail?: string;
  contactPhone?: string;
  regionId?: number;
  commissionSplitPct?: number;
}

export interface MasterDealerUpdate {
  /** @minLength 1 */
  name?: string;
  contactEmail?: string;
  contactPhone?: string;
  regionId?: number;
  status?: AgentStatus;
  commissionSplitPct?: number;
}

export type AccountManagerAssignmentMode = typeof AccountManagerAssignmentMode[keyof typeof AccountManagerAssignmentMode];


export const AccountManagerAssignmentMode = {
  region_area: 'region_area',
  round_robin: 'round_robin',
} as const;

export interface AccountManager {
  id: number;
  name: string;
  email: string;
  /** @nullable */
  phone?: string | null;
  agentsManaged?: number;
  openTickets?: number;
  workloadScore?: number;
  assignmentMode?: AccountManagerAssignmentMode;
  createdAt?: string;
  /** @nullable */
  archivedAt?: string | null;
}

export type AccountManagerInputAssignmentMode = typeof AccountManagerInputAssignmentMode[keyof typeof AccountManagerInputAssignmentMode];


export const AccountManagerInputAssignmentMode = {
  region_area: 'region_area',
  round_robin: 'round_robin',
} as const;

export interface AccountManagerInput {
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  email: string;
  phone?: string;
  assignmentMode?: AccountManagerInputAssignmentMode;
}

export type AccountManagerUpdateAssignmentMode = typeof AccountManagerUpdateAssignmentMode[keyof typeof AccountManagerUpdateAssignmentMode];


export const AccountManagerUpdateAssignmentMode = {
  region_area: 'region_area',
  round_robin: 'round_robin',
} as const;

export interface AccountManagerUpdate {
  /** @minLength 1 */
  name?: string;
  phone?: string;
  assignmentMode?: AccountManagerUpdateAssignmentMode;
}

export interface AgentCompliance {
  hasOnboarding: boolean;
  /** @nullable */
  onboardingId?: number | null;
  /** @nullable */
  onboardingStatus?: string | null;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  idNumberMasked?: string | null;
  /** @nullable */
  addressLine?: string | null;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  province?: string | null;
  /** @nullable */
  postalCode?: string | null;
  /** @nullable */
  reviewerNotes?: string | null;
  /** @nullable */
  reviewedAt?: string | null;
  msaRequired: boolean;
  /** @nullable */
  msaAgentSignedName?: string | null;
  /** @nullable */
  msaAgentSignedAt?: string | null;
  /** @nullable */
  msaAdminSignedName?: string | null;
  /** @nullable */
  msaAdminSignedAt?: string | null;
  msaFullySigned: boolean;
  msaDocumentAvailable: boolean;
}

export interface LmsAttemptSummary {
  score: number;
  passed: boolean;
  totalQuestions: number;
  passMark: number;
  completedAt: string;
}

export interface AgentTraining {
  hasUser: boolean;
  completed: boolean;
  currentSlide: number;
  totalSlides: number;
  latestAttempt?: LmsAttemptSummary | null;
}

export interface AgentNotificationSummary {
  id: number;
  type: string;
  title: string;
  body: string;
  /** @nullable */
  readAt?: string | null;
  createdAt: string;
}

export interface AgentNotifications {
  hasUser: boolean;
  items: AgentNotificationSummary[];
  total: number;
}

export interface AgentInput {
  /** @minLength 1 */
  name: string;
  email?: string;
  phone?: string;
  type: AgentType;
  areaId?: number;
  masterDealerId?: number;
  accountManagerId?: number;
  /** @minLength 1 */
  openserveDealerCode: string;
}

export interface AgentUpdate {
  /** @minLength 1 */
  name?: string;
  email?: string;
  phone?: string;
  type?: AgentType;
  status?: AgentStatus;
  areaId?: number;
  masterDealerId?: number;
  accountManagerId?: number;
  openserveDealerCode?: string;
}

export interface Invitation {
  id: number;
  recipientFirstName: string;
  recipientLastName: string;
  recipientContact?: string;
  channel: InvitationChannel;
  status: InvitationStatus;
  targetRole?: UserRole | null;
  /** @nullable */
  masterDealerId?: number | null;
  /** @nullable */
  infoSessionId?: number | null;
  /** @nullable */
  acceptedByUserId?: number | null;
  /** @nullable */
  acceptedAt?: string | null;
  /** @nullable */
  expiresAt?: string | null;
  sentAt?: string;
}

export type CreateInvitationResponse = Invitation & ({
  /** Deprecated alias of `delivered`, retained for backward compatibility. Whether the invitation was accepted for delivery by the channel provider (email/SMS/WhatsApp). */
  emailDelivered: boolean;
  /**
     * Deprecated alias of `deliveryError`.
     * @nullable
     */
  emailError?: string | null;
  /** Whether the invitation was accepted for delivery by the channel provider. */
  delivered?: boolean;
  /**
     * If delivery failed, a human-readable reason; otherwise null.
     * @nullable
     */
  deliveryError?: string | null;
  deliveryChannel?: InvitationChannel;
  /**
     * Provider-assigned message identifier when available.
     * @nullable
     */
  providerMessageId?: string | null;
});

export interface InvitationInput {
  /** @minLength 1 */
  recipientFirstName: string;
  /** @minLength 1 */
  recipientLastName: string;
  /**
     * Email for the email channel; an SA mobile number for the sms/whatsapp channels. Validated per-channel by the server.
     * @minLength 1
     */
  recipientContact: string;
  channel: InvitationChannel;
  targetRole?: UserRole;
  masterDealerId?: number;
  infoSessionId?: number;
}

export interface InvitationUpdate {
  status?: InvitationStatus;
  targetRole?: UserRole;
  infoSessionId?: number;
}

export interface LmsExamOption {
  key: string;
  label: string;
}

export interface LmsExamQuestion {
  id: string;
  prompt: string;
  options: LmsExamOption[];
}

export interface LmsExam {
  questions: LmsExamQuestion[];
  /** Minimum number of correct answers required to pass. */
  passMark: number;
  totalQuestions: number;
}

export interface LmsProgress {
  currentSlide: number;
  completed: boolean;
  totalSlides: number;
  latestAttempt?: LmsAttemptSummary | null;
}

export interface LmsProgressInput {
  /** @minimum 0 */
  currentSlide: number;
}

export interface LmsAssessmentAnswer {
  /** @minLength 1 */
  questionId: string;
  /** @minLength 1 */
  selectedKey: string;
}

export interface LmsAssessmentInput {
  answers: LmsAssessmentAnswer[];
}

export interface LmsAssessmentResult {
  score: number;
  passed: boolean;
  totalQuestions: number;
  passMark: number;
}

export interface ApplicationInput {
  /** @minLength 1 */
  applicantName: string;
  email?: string;
  phone?: string;
  agentType: AgentType;
  masterDealerId?: number;
}

export interface ApplicationUpdate {
  status?: ApplicationStatus;
  ficaComplete?: boolean;
  reviewerNotes?: string;
  /** @nullable */
  openserveAgentId?: string | null;
}

export interface OrderInput {
  /** @minLength 1 */
  customerName: string;
  address?: string;
  /** @minLength 1 */
  package: string;
  priceCents: number;
  isp?: string;
  agentId?: number;
}

export interface OrderUpdate {
  status?: OrderStatus;
  address?: string;
  /** @minLength 1 */
  package?: string;
  priceCents?: number;
}

export interface Wallet {
  agentId: number;
  balanceCents: number;
  pendingCents: number;
  heldCents: number;
  transactions: Transaction[];
}

export interface TransactionInput {
  agentId: number;
  amountCents: number;
  type: TransactionType;
  orderId?: number;
  heldReason?: string;
}

export interface PaymentRun {
  id: number;
  reference: string;
  status: PaymentRunStatus;
  totalOnceOffFeesCents?: number;
  totalRecurringCommCents?: number;
  totalPayoutValueCents: number;
  agentsToPay?: number;
  /** @nullable */
  eftFileName?: string | null;
  /** @nullable */
  exportedAt?: string | null;
  /** @nullable */
  reconciledAt?: string | null;
  createdAt?: string;
}

export interface PaymentRunItem {
  id: number;
  /** @nullable */
  agentId?: number | null;
  agentName: string;
  /** @nullable */
  bankName?: string | null;
  /** @nullable */
  accountNumberMasked?: string | null;
  onceOffCents?: number;
  recurringCents?: number;
  totalDueCents: number;
  status: PayoutStatus;
  /** @nullable */
  heldReason?: string | null;
  /** @nullable */
  bankReference?: string | null;
  /** @nullable */
  failureReason?: string | null;
  /** @nullable */
  paidAt?: string | null;
}

export interface PaymentRunDetail {
  id: number;
  reference: string;
  status: PaymentRunStatus;
  totalOnceOffFeesCents?: number;
  totalRecurringCommCents?: number;
  totalPayoutValueCents?: number;
  agentsToPay?: number;
  items: PaymentRunItem[];
  /** @nullable */
  eftFileName?: string | null;
  /** @nullable */
  exportedAt?: string | null;
  /** @nullable */
  reconciledAt?: string | null;
  createdAt?: string;
}

export interface PaymentRunInput {
  reference?: string;
}

export interface PaymentRunUpdate {
  status?: PaymentRunStatus;
}

export interface EftExportResult {
  fileName: string;
  content: string;
  itemsExported: number;
  itemsHeld?: number;
  totalCents: number;
}

export interface FailPaymentRunInput {
  reason?: string;
}

export interface ReconcilePaymentRunInput {
  /** @minLength 1 */
  objectPath: string;
  /** @minLength 1 */
  fileName: string;
}

export interface ReconciledRow {
  /** @nullable */
  reference?: string | null;
  /** @nullable */
  agentName?: string | null;
  /** @nullable */
  accountNumberMasked?: string | null;
  /** @nullable */
  amountCents?: number | null;
  /** @nullable */
  bankReference?: string | null;
  matched: boolean;
  outcome: string;
  /** @nullable */
  note?: string | null;
}

export interface ReconcileSummary {
  total: number;
  paid: number;
  failed: number;
  mismatch?: number;
  duplicate?: number;
  unmatched: number;
  unresolvedItems?: number;
  paidValueCents?: number;
}

export interface ReconcilePaymentRunResult {
  run: PaymentRunDetail;
  summary: ReconcileSummary;
  rows: ReconciledRow[];
}

export interface BankChangeRequest {
  id: number;
  /** @nullable */
  agentId?: number | null;
  agentName: string;
  status: BankChangeStatus;
  /** @nullable */
  currentBankName?: string | null;
  newBankName: string;
  newAccountNumberMasked: string;
  /** @nullable */
  newBranchCode?: string | null;
  /** @nullable */
  accountType?: string | null;
  /** @nullable */
  verificationMethod?: string | null;
  /** @nullable */
  reviewerNotes?: string | null;
  submittedAt?: string;
}

export interface BankChangeRequestInput {
  agentId: number;
  /** @minLength 1 */
  newBankName: string;
  /** @minLength 1 */
  newAccountNumber: string;
  /** @minLength 1 */
  newBranchCode: string;
  /** @minLength 1 */
  accountType: string;
  /**
     * One-time token proving the agent completed dual-channel (SMS + email) OTP verification. Issued by /bank-change-verifications and consumed atomically when the request is created.
     * @minLength 1
     */
  verificationToken: string;
}

export interface BankChangeRequestUpdate {
  status?: BankChangeStatus;
  verificationMethod?: string;
  reviewerNotes?: string;
}

export interface MsaPrefill {
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  idNumber?: string | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  addressLine?: string | null;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  province?: string | null;
  /** @nullable */
  postalCode?: string | null;
  /** @nullable */
  preferredOperatingArea?: string | null;
  /** @nullable */
  agentType?: string | null;
}

export interface MsaClause {
  heading: string;
  body: string;
}

/**
 * The agreement body text, served so the portal can render an on-screen HTML contract identical to the executed PDF (single source of truth).
 */
export interface MsaContract {
  title: string;
  intro: string;
  clauses: MsaClause[];
  signatureNote: string;
  agentRoleLabel: string;
  mooyaRoleLabel: string;
}

export interface MsaStatus {
  onboardingId: number;
  /** Whether the agreement applies to this onboarding. True only for self-service field-sales agents; other types do not need the MSA. */
  required: boolean;
  agentSigned: boolean;
  /** @nullable */
  agentSignedName?: string | null;
  /**
     * The agent's hand-drawn signature as a base64 PNG data URL, or null until signed.
     * @nullable
     */
  agentSignatureImage?: string | null;
  /**
     * The client IP captured when the agent signed (audit metadata). Only populated on reviewer/admin-facing responses; null on self-service responses.
     * @nullable
     */
  agentSignedIp?: string | null;
  /** @nullable */
  agentSignedAt?: number | null;
  adminSigned: boolean;
  /** @nullable */
  adminSignedName?: string | null;
  /**
     * Mooya's hand-drawn counter-signature as a base64 PNG data URL, or null until counter-signed.
     * @nullable
     */
  adminSignatureImage?: string | null;
  /**
     * The client IP captured when Mooya counter-signed (audit metadata). Only populated on reviewer/admin-facing responses; null on self-service responses.
     * @nullable
     */
  adminSignedIp?: string | null;
  /** @nullable */
  adminSignedAt?: number | null;
  fullySigned: boolean;
  documentAvailable: boolean;
  contract: MsaContract;
  prefill: MsaPrefill;
}

export interface MsaSendResult {
  /** Whether the agreement email was accepted for delivery. */
  sent: boolean;
  /** The agent email address the agreement was sent to. */
  recipientEmail: string;
  /** True when the executed PDF was attached; false when only a portal link was sent (agreement not yet fully signed). */
  documentAttached: boolean;
}

export interface MsaSignBody {
  /**
     * The signer's hand-drawn signature as a base64 PNG data URL (`data:image/png;base64,...`). The signer name is NOT supplied — it is derived server-side from the registration record.
     * @minLength 1
     */
  signatureImage: string;
  /** Must be true; the signer agrees to be legally bound. */
  consent: boolean;
}

export interface BankChangeVerificationStatus {
  id: number;
  smsVerified: boolean;
  emailVerified: boolean;
  completed: boolean;
  /** Epoch milliseconds when the session expires. */
  expiresAt: number;
  /** @nullable */
  maskedPhone?: string | null;
  /** @nullable */
  maskedEmail?: string | null;
  /**
     * One-time token, returned ONLY once both channels are verified. Pass it to POST /bank-change-requests to authorise the change.
     * @nullable
     */
  verificationToken?: string | null;
}

export type BankChangeVerifyBodyChannel = typeof BankChangeVerifyBodyChannel[keyof typeof BankChangeVerifyBodyChannel];


export const BankChangeVerifyBodyChannel = {
  sms: 'sms',
  email: 'email',
} as const;

export interface BankChangeVerifyBody {
  channel: BankChangeVerifyBodyChannel;
  /**
     * @minLength 6
     * @maxLength 6
     */
  code: string;
}

export interface AccountActivationStatus {
  /** True once the account is fully activated (both channels verified). */
  activated: boolean;
  /** True when an in-progress (unexpired, unconsumed) session exists. */
  hasSession: boolean;
  smsVerified: boolean;
  emailVerified: boolean;
  /** False once the per-session resend cap is reached. */
  canResend: boolean;
  /**
     * Epoch milliseconds when the current session expires; null when none.
     * @nullable
     */
  expiresAt?: number | null;
  /** @nullable */
  maskedPhone?: string | null;
  /** @nullable */
  maskedEmail?: string | null;
}

export interface StartAccountActivationBody {
  /**
     * South African mobile number to verify (any common SA format).
     * @minLength 1
     */
  phone: string;
}

export type AccountActivationVerifyBodyChannel = typeof AccountActivationVerifyBodyChannel[keyof typeof AccountActivationVerifyBodyChannel];


export const AccountActivationVerifyBodyChannel = {
  sms: 'sms',
  email: 'email',
} as const;

export interface AccountActivationVerifyBody {
  channel: AccountActivationVerifyBodyChannel;
  /**
     * @minLength 6
     * @maxLength 6
     */
  code: string;
}

export interface CompleteProfileBody {
  /** @minLength 1 */
  fullName: string;
  /** @minLength 1 */
  phone: string;
  /** @minLength 1 */
  jobTitle: string;
}

export interface Dispute {
  id: number;
  reference: string;
  subject: string;
  /** @nullable */
  description?: string | null;
  status: DisputeStatus;
  /** @nullable */
  agentId?: number | null;
  /** @nullable */
  agentName?: string | null;
  /** @nullable */
  orderId?: number | null;
  /** @nullable */
  amountCents?: number | null;
  /** @nullable */
  resolutionNotes?: string | null;
  createdAt?: string;
}

export interface DisputeInput {
  /** @minLength 1 */
  subject: string;
  description?: string;
  agentId?: number;
  orderId?: number;
  amountCents?: number;
}

export interface DisputeUpdate {
  status?: DisputeStatus;
  resolutionNotes?: string;
}

export type MarketingMaterialCategory = typeof MarketingMaterialCategory[keyof typeof MarketingMaterialCategory];


export const MarketingMaterialCategory = {
  flyer: 'flyer',
  product: 'product',
  brochure: 'brochure',
  other: 'other',
} as const;

export interface MarketingMaterial {
  id: number;
  title: string;
  /** @nullable */
  description?: string | null;
  category: MarketingMaterialCategory;
  /** Canonical /objects/... entity path. Serve/download via /api/storage{fileUrl} (same convention as profilePhotoUrl). */
  fileUrl: string;
  fileName: string;
  contentType: string;
  fileSizeBytes: number;
  /** @nullable */
  uploadedByName?: string | null;
  createdAt: string;
}

export interface MarketingMaterialInput {
  /** @minLength 1 */
  title: string;
  description?: string;
  category: MarketingMaterialCategory;
  /**
     * The /objects/... path returned by the upload request-url flow.
     * @minLength 1
     */
  objectPath: string;
  /** @minLength 1 */
  fileName: string;
  contentType: string;
  /** @minimum 1 */
  fileSizeBytes: number;
}

export interface TicketAssignee {
  id: number;
  name: string;
}

export interface TicketMessage {
  id: number;
  ticketId?: number;
  sender: string;
  body: string;
  createdAt: string;
}

export interface TicketDetail {
  id: number;
  reference: string;
  subject: string;
  status: TicketStatus;
  priority: TicketPriority;
  /** @nullable */
  agentId?: number | null;
  /** @nullable */
  agentName?: string | null;
  /** @nullable */
  assignedToId?: number | null;
  messages: TicketMessage[];
  createdAt?: string;
}

export interface TicketInput {
  /** @minLength 1 */
  subject: string;
  priority?: TicketPriority;
  agentId?: number;
  body?: string;
}

export interface TicketUpdate {
  status?: TicketStatus;
  priority?: TicketPriority;
  /** @nullable */
  assignedToId?: number | null;
}

export interface TicketMessageInput {
  /** @minLength 1 */
  body: string;
}

export interface InfoSession {
  id: number;
  title: string;
  /** @nullable */
  location?: string | null;
  scheduledAt: string;
  status: InfoSessionStatus;
  /** @nullable */
  capacity?: number | null;
  invitedCount?: number;
  attendedCount?: number;
  /** @nullable */
  hostId?: number | null;
}

export interface InfoSessionInput {
  /** @minLength 1 */
  title: string;
  location?: string;
  scheduledAt: string;
  capacity?: number;
  hostId?: number;
}

export interface InfoSessionUpdate {
  /** @minLength 1 */
  title?: string;
  location?: string;
  scheduledAt?: string;
  status?: InfoSessionStatus;
  capacity?: number;
}

export interface DataImport {
  id: number;
  fileName: string;
  source: string;
  status: DataImportStatus;
  rowsTotal?: number;
  rowsProcessed?: number;
  rowsFailed?: number;
  /** @nullable */
  importedById?: number | null;
  /** @nullable */
  importedByName?: string | null;
  /** @nullable */
  notifiedAt?: string | null;
  createdAt?: string;
}

export type DataImportKind = typeof DataImportKind[keyof typeof DataImportKind];


export const DataImportKind = {
  leads_report: 'leads_report',
  omoo_claim: 'omoo_claim',
} as const;

export interface CommissionPlanRate {
  id: number;
  planId: number;
  packageKey: string;
  label: string;
  commissionCents: number;
}

export interface CommissionPlan {
  id: number;
  name: string;
  /** @nullable */
  description?: string | null;
  isDefault: boolean;
  thresholdFreeCount: number;
  retainerCents: number;
  retainerMinLeads: number;
  retainerMinActivations: number;
  agentCount?: number;
  rates: CommissionPlanRate[];
}

export interface CommissionRateInput {
  /** @minLength 1 */
  packageKey: string;
  /** @minLength 1 */
  label: string;
  /** @minimum 0 */
  commissionCents: number;
}

export interface UpdateCommissionRatesInput {
  rates: CommissionRateInput[];
}

export interface AgentCommissionPlanUpdate {
  /** @nullable */
  commissionPlanId?: number | null;
}

export interface ProcessDataImportInput {
  /** @minLength 1 */
  objectPath: string;
  /** @minLength 1 */
  fileName: string;
  kind: DataImportKind;
}

export interface ImportSummary {
  total: number;
  installed: number;
  pending: number;
  cancelled: number;
  agentsUpdated: number;
  matched?: number;
  unmatched?: number;
  totalValueCents?: number;
  created?: number;
  updated?: number;
  unchanged?: number;
  agentsUnmatched?: number;
  credited?: number;
  alreadyCredited?: number;
  creditedValueCents?: number;
  retainerValueCents?: number;
  flaggedUnmapped?: number;
}

export interface ProcessedRow {
  /** @nullable */
  leadId?: string | null;
  /** @nullable */
  agentName?: string | null;
  /** @nullable */
  agentCode?: string | null;
  /** @nullable */
  isp?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  customer?: string | null;
  /** @nullable */
  orderNumber?: string | null;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  claimRef?: string | null;
  /** @nullable */
  product?: string | null;
  /** @nullable */
  onceOffFeeCents?: number | null;
  /** @nullable */
  period?: string | null;
  matched: boolean;
  /** @nullable */
  note?: string | null;
  /** @nullable */
  commissionCents?: number | null;
  /** @nullable */
  packageKey?: string | null;
  /** @nullable */
  rateFlagged?: boolean | null;
}

export interface ProcessDataImportResult {
  import: DataImport;
  summary: ImportSummary;
  rows: ProcessedRow[];
}

export interface NotifyAgentsResult {
  agentsNotified: number;
  notificationsCreated: number;
  emailsSent: number;
  alreadyNotified: boolean;
}

export interface Notification {
  id: number;
  userId: number;
  type: string;
  title: string;
  body: string;
  /** @nullable */
  dataImportId?: number | null;
  /** @nullable */
  readAt?: string | null;
  createdAt: string;
}

export interface ImportOrderChange {
  id: number;
  orderId: number;
  /** @nullable */
  orderReference?: string | null;
  /** @nullable */
  customerName?: string | null;
  /** @nullable */
  previousStatus?: string | null;
  newStatus: string;
}

export interface DataImportInput {
  /** @minLength 1 */
  fileName: string;
  /** @minLength 1 */
  source: string;
  rowsTotal?: number;
}

export interface AuditLog {
  id: number;
  action: string;
  entityType: string;
  /** @nullable */
  entityId?: number | null;
  /** @nullable */
  actorName?: string | null;
  /** @nullable */
  detail?: string | null;
  createdAt: string;
}

/**
 * Resource not found
 */
export type NotFoundResponse = Error;

/**
 * Unauthorized
 */
export type UnauthorizedResponse = Error;

/**
 * Forbidden
 */
export type ForbiddenResponse = Error;

/**
 * 1-based page number.
 */
export type PageParamParameter = number;

/**
 * Number of items per page.
 */
export type PageSizeParamParameter = number;

export type ListAdminUsersParams = {
role?: UserRole;
/**
 * 1-based page number.
 * @minimum 1
 */
page?: PageParamParameter;
/**
 * Number of items per page.
 * @minimum 1
 * @maximum 100
 */
pageSize?: PageSizeParamParameter;
};

export type ListAdminUsers200 = {
  items: CurrentUser[];
  total: number;
  page: number;
  pageSize: number;
};

export type ListStaffInvitations200 = {
  items: StaffInvitation[];
};

export type ListAreasParams = {
regionId?: number;
};

export type ListMasterDealersParams = {
/**
 * When true, include archived (soft-deleted) master dealers.
 */
includeArchived?: boolean;
/**
 * 1-based page number.
 * @minimum 1
 */
page?: PageParamParameter;
/**
 * Number of items per page.
 * @minimum 1
 * @maximum 100
 */
pageSize?: PageSizeParamParameter;
};

export type ListMasterDealers200 = {
  items: MasterDealer[];
  total: number;
  page: number;
  pageSize: number;
};

export type ListAccountManagersParams = {
/**
 * When true, include archived (soft-deleted) account managers.
 */
includeArchived?: boolean;
};

export type ListAgentsParams = {
status?: AgentStatus;
areaId?: number;
masterDealerId?: number;
accountManagerId?: number;
/**
 * 1-based page number.
 * @minimum 1
 */
page?: PageParamParameter;
/**
 * Number of items per page.
 * @minimum 1
 * @maximum 100
 */
pageSize?: PageSizeParamParameter;
};

export type ListAgents200 = {
  items: Agent[];
  total: number;
  page: number;
  pageSize: number;
};

export type ListCommissionPlans200 = {
  items: CommissionPlan[];
};

export type ListInvitationsParams = {
status?: InvitationStatus;
/**
 * 1-based page number.
 * @minimum 1
 */
page?: PageParamParameter;
/**
 * Number of items per page.
 * @minimum 1
 * @maximum 100
 */
pageSize?: PageSizeParamParameter;
};

export type ListInvitations200 = {
  items: Invitation[];
  total: number;
  page: number;
  pageSize: number;
};

export type ListApplicationsParams = {
status?: ApplicationStatus;
/**
 * 1-based page number.
 * @minimum 1
 */
page?: PageParamParameter;
/**
 * Number of items per page.
 * @minimum 1
 * @maximum 100
 */
pageSize?: PageSizeParamParameter;
};

export type ListApplications200 = {
  items: Application[];
  total: number;
  page: number;
  pageSize: number;
};

export type ListOnboardingReviewsParams = {
status?: OnboardingStatus;
};

export type ListOrdersParams = {
status?: OrderStatus;
agentId?: number;
search?: string;
leadStatus?: string;
region?: string;
/**
 * 1-based page number.
 * @minimum 1
 */
page?: PageParamParameter;
/**
 * Number of items per page.
 * @minimum 1
 * @maximum 100
 */
pageSize?: PageSizeParamParameter;
};

export type ListOrders200 = {
  items: Order[];
  total: number;
  page: number;
  pageSize: number;
};

export type ListTransactionsParams = {
agentId?: number;
status?: PayoutStatus;
/**
 * 1-based page number.
 * @minimum 1
 */
page?: PageParamParameter;
/**
 * Number of items per page.
 * @minimum 1
 * @maximum 100
 */
pageSize?: PageSizeParamParameter;
};

export type ListTransactions200 = {
  items: Transaction[];
  total: number;
  page: number;
  pageSize: number;
};

export type ListBankChangeRequestsParams = {
status?: BankChangeStatus;
};

export type ListDisputesParams = {
status?: DisputeStatus;
agentId?: number;
/**
 * 1-based page number.
 * @minimum 1
 */
page?: PageParamParameter;
/**
 * Number of items per page.
 * @minimum 1
 * @maximum 100
 */
pageSize?: PageSizeParamParameter;
};

export type ListDisputes200 = {
  items: Dispute[];
  total: number;
  page: number;
  pageSize: number;
};

export type ListTicketsParams = {
status?: TicketStatus;
priority?: TicketPriority;
agentId?: number;
/**
 * 1-based page number.
 * @minimum 1
 */
page?: PageParamParameter;
/**
 * Number of items per page.
 * @minimum 1
 * @maximum 100
 */
pageSize?: PageSizeParamParameter;
};

export type ListTickets200 = {
  items: Ticket[];
  total: number;
  page: number;
  pageSize: number;
};

export type ListInfoSessionsParams = {
/**
 * 1-based page number.
 * @minimum 1
 */
page?: PageParamParameter;
/**
 * Number of items per page.
 * @minimum 1
 * @maximum 100
 */
pageSize?: PageSizeParamParameter;
};

export type ListInfoSessions200 = {
  items: InfoSession[];
  total: number;
  page: number;
  pageSize: number;
};

export type ListDataImportsParams = {
/**
 * 1-based page number.
 * @minimum 1
 */
page?: PageParamParameter;
/**
 * Number of items per page.
 * @minimum 1
 * @maximum 100
 */
pageSize?: PageSizeParamParameter;
};

export type ListDataImports200 = {
  items: DataImport[];
  total: number;
  page: number;
  pageSize: number;
};

export type ListAuditLogsParams = {
entityType?: string;
entityId?: number;
/**
 * 1-based page number.
 * @minimum 1
 */
page?: PageParamParameter;
/**
 * Number of items per page.
 * @minimum 1
 * @maximum 100
 */
pageSize?: PageSizeParamParameter;
};

export type ListAuditLogs200 = {
  items: AuditLog[];
  total: number;
  page: number;
  pageSize: number;
};

export type ListMarketingMaterialsParams = {
category?: MarketingMaterialCategory;
};

export type ListMarketingMaterials200 = {
  items: MarketingMaterial[];
};

